module.exports = "/images/check.svg?13c7011207d233cd29e679174186269d";